export const USERS_TIPO_LOADED = 'USERS_TIPO_LOADED';
export const USERS_TIPO_LOADING = 'USERS_TIPO_LOADING';
export const USERS_TIPO_ERROR = 'USERS_TIPO_ERROR';

export const USERSELECT_LOAD = 'USERSELECT_LOAD';
export const USERSELECT_LOADING = 'USERSELECT_LOADING';
export const USERSELECT_ERROR = 'USERSELECT_ERROR';

export const USERALL_LOAD = 'USERALL_LOAD';
export const USERALL_LOADING = 'USERALL_LOADING';
export const USERALL_ERROR = 'USERALL_ERROR';

export const USER_LOADING = 'USER_LOADING';
export const USER_LOADED = 'USER_LOADED';

export const AUTH_ERROR = 'AUTH_ERROR';

export const REGISTER_SUCCESS = 'REGISTER_SUCCESS';
export const REGISTER_FAIL = 'REGISTER_FAIL';

export const LOGIN_SUCCESS = 'LOGIN_SUCCESS';
export const LOGIN_FAIL = 'LOGIN_FAIL';
export const LOGOUT_SUCCESS = 'LOGOUT_SUCCESS';
export const LOGIN_LOADING = 'LOGIN_LOADING';

export const USER_LOADED_ALL = 'USER_LOADED_ALL';

export const USER_EDIT_LOADING = 'USER_EDIT_LOADING';
export const USER_EDIT_LOADED = 'USER_EDIT_LOADED';
export const USER_EDIT_ERROR = 'USER_EDIT_ERROR';
export const USER_EDIT_RESET = 'USER_EDIT_RESET';

export const USER_NATURALISTA_LOADED = 'USER_NATURALISTA_LOADED';
export const USER_NATURALISTA_ERROR = 'USER_NATURALISTA_ERROR';
export const USER_NATURALISTA_LOADING = 'USER_NATURALISTA_LOADING';
export const USER_NATURALISTA_COUNT_LOADED = 'USER_NATURALISTA_COUNT_LOADED';

export const USERS_DATA_LOADING = 'USERS_DATA_LOADING';
export const USERS_DATA_LOADED = 'USERS_DATA_LOADED';
export const USERS_DATA_ERROR = 'USERS_DATA_ERROR';

export const REGISTER_USER_LOADING = 'REGISTER_USER_LOADING';
export const REGISTER_USER_LOADED = 'REGISTER_USER_LOADED';
export const REGISTER_USER_ERROR = 'REGISTER_USER_ERROR';
